import React, { Component } from "react";
import ComingSoon from "../assets/ComingSoon.png";
import { Card } from "@material-ui/core";
import EmailSignupConsumer from "../components/EmailSignupConsumer";
import Kinder from "../assets/Kinder.svg";
import KinderLogo from "../assets/KinderLogo.png";
import Chat from "../assets/Chat.svg";
import Rewards from "../assets/Rewards.svg";
import KinderTask from "../assets/KinderTask.svg";
import MobileHeader from "../components/MobileHeader";
import Thanks from "../assets/Thanks.png";
import Ask from "../assets/Ask.png";
import Hunter from "../assets/Hunter.png";
import Spencer from "../assets/Spencer.png";
import { slideInLeft, slideInRight } from "react-animations";
import Radium, { StyleRoot } from "radium";
import { Footer } from "../components/Footer";
import ScrollAnimation from "react-animate-on-scroll";
var Scroll = require("react-scroll");
var _ = require("lodash");

var ReactRotatingText = require("react-rotating-text");

var Link = Scroll.Link;
var Element = Scroll.Element;
let scroll = Scroll.animateScroll;

class ProhibitedUse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scrollY: 0
    };
  }

  componentDidMount = () => {
    window.addEventListener("scroll", this.checkHeader);
  };

  checkHeader = _.throttle(() => {
    this.setState({ scrollY: Math.round(window.scrollY) });
  }, 300);

  scrollToTop() {
    scroll.scrollToTop();
  }

  render() {
    const { pp } = this.state;
    if (this.state.scrollY > 50) {
      var transformValue = "scaleY(1)";
    } else {
      var transformValue = "scaleY(0)";
    }
    return (
      <div
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          fontFamily: "Quicksand"
        }}
      >
        {window.innerWidth > 1200 && (
          <div
            className="row"
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              height: "5%",
              alignItems: "center",
              justifyContent: "space-between",
              overflow: "hidden",
              position: "fixed",
              top: 0,
              backgroundColor: "#414141",
              zIndex: 100000,
              transition: "transform 0.3s ease-out", // note that we're transitioning transform, not height!
              transform: transformValue
            }}
          >
            {/* <div style={{ position: "absolute", left: 40, top: 10 }}> */}
            <div
              className="col"
              style={{ marginLeft: "10%" }}
              onClick={this.scrollToTop}
            >
              <p
                style={{
                  fontFamily: "Quicksand",
                  color: "white",
                  fontSize: 30
                }}
              >
                Kinder
              </p>
            </div>

            <div
              className="col"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-evenly",
                marginRight: "10%"
              }}
            >
              <Link
                to="how"
                smooth={true}
                offset={0}
                duration={500}
                style={{
                  color: "white",
                  marginRight: "15%",
                  fontSize: 30,
                  cursor: "pointer"
                }}
              >
                how
              </Link>
              <Link
                to="what"
                smooth={true}
                offset={0}
                duration={500}
                style={{
                  color: "white",
                  marginRight: "15%",
                  fontSize: 30,
                  cursor: "pointer"
                }}
              >
                what
              </Link>
              <Link
                to="who"
                smooth={true}
                offset={0}
                duration={500}
                style={{
                  color: "white",
                  marginRight: "15%",
                  fontSize: 30,
                  cursor: "pointer"
                }}
              >
                who
              </Link>
            </div>
          </div>
        )}

        {window.innerWidth > 1200 && (
          <div
            className="row"
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              height: "5%",
              alignItems: "center",
              justifyContent: "space-between",
              overflow: "hidden",
              top: 0,
              backgroundColor: "white",
              zIndex: 100000
            }}
          >
            {/* <div style={{ position: "absolute", left: 40, top: 10 }}> */}
            <div
              className="col"
              style={{ marginLeft: "10%", marginTop: "0.5%" }}
              onClick={this.scrollToTop}
            >
              <img
                src={KinderLogo}
                alt="Kinder Logo"
                style={{ width: "90px" }}
              />
            </div>

            <div
              className="col"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-evenly",
                marginRight: "10%"
              }}
            >
              <Link
                to="how"
                smooth={true}
                offset={0}
                duration={500}
                style={{
                  color: "#1c6bf7",
                  marginRight: "15%",
                  fontSize: 30,
                  cursor: "pointer"
                }}
              >
                how
              </Link>
              <Link
                to="what"
                smooth={true}
                offset={0}
                duration={500}
                style={{
                  color: "#1c6bf7",
                  marginRight: "15%",
                  fontSize: 30,
                  cursor: "pointer"
                }}
              >
                what
              </Link>
              <Link
                to="who"
                smooth={true}
                offset={0}
                duration={500}
                style={{
                  color: "#1c6bf7",
                  marginRight: "15%",
                  fontSize: 30,
                  cursor: "pointer"
                }}
              >
                who
              </Link>
            </div>
          </div>
        )}

        <div
          className="row"
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "space-evenly",
            alignItems: "center",
            textAlign: "center",
            paddingTop: "5%",
            paddingBottom: "10%",
            overflow: "hidden",
            backgroundColor: "white",
            flexWrap: "wrap"
          }}
        >
          <div
            className="col"
            style={{
              width: "50%",
              justifyContent: "center",
              alignItems: "flex-start",
              textAlign: "left",
              alignSelf: "flex-start",
              flexWrap: "wrap",
              marginBottom: "5%",
              fontFamily: "Quicksand"
            }}
          >
          <h1 style={{fontFamily:"Quicksand"}}>
          Prohibited use
          </h1>
      Users must comply with all applicable laws, the KinderUS terms of use, and all posted site rules.
          <br/>
          <br/>
      Here is a partial list of goods, services, and content prohibited on KinderUS:
      <br/>
      <br/>
      - weapons; firearms/guns and components; BB/pellet, stun, and spear guns; etc
      ammunition, clips, cartridges, reloading materials, gunpowder, fireworks, explosives
      <br/>
      - offers, solicitation, or facilitation of illegal prostitution and/or sex trafficking
      exploitation or endangerment of minors; child pornography
      <br/>
      - recalled items; hazardous materials; body parts/fluids; unsanitized bedding/clothing
      <br/>
      - prescription drugs, medical devices; controlled substances and related items
      alcohol or tobacco; unpackaged or adulterated food or cosmetics
      <br/>
      - pet sales (re-homing with small adoption fee ok), animal parts, stud service
      endangered, imperiled and/or protected species and any parts thereof, e.g. ivory
      <br/>
      -false, misleading, deceptive, or fraudulent content; bait and switch; keyword spam
      <br/>
      -offensive, obscene, defamatory, threatening, or malicious postings or email
      <br/>
      - anyone’s personal, identifying, confidential or proprietary information
      <br/>
      - food stamps, WIC vouchers, SNAP or WIC goods, governmental assistance
      <br/>
      - stolen property, property with serial number removed/altered, burglary tools, etc
      <br/>
      - ID cards, licenses, police insignia, government documents, birth certificates, etc
      <br/>
      - US military items not demilitarized in accord with Defense Department policy
      <br/>
      - counterfeit, replica, or pirated items; tickets or gift cards that restrict transfer
      <br/>
      - lottery or raffle tickets, sweepstakes entries, slot machines, gambling items
      <br/>
      - spam; miscategorized, overposted, cross-posted, or nonlocal content
      <br/>
      - postings or email the primary purpose of which is to drive traffic to a website
      <br/>
      - postings or email offering, promoting, or linking to unsolicited products or services
      <br/>
      - affiliate marketing; network, or multi-level marketing; pyramid schemes
      <br/>
      - any good, service, or content that violates the law or legal rights of others
      <br/>
      <br/>
      Please don't use KinderUS for these purposes, and notify post(at)kindertogether.com if you see anyone else doing so.
      <br/>
      <br/>
      Thanks for helping keep KinderUS safe and useful for everyone.
          </div>
        </div>
        <div
          className="row"
          style={{
            display: "flex",
            padding: "2% 2% 2% 2%",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#414141"
          }}
        >
          <div className="col" style={{ width: "90%", flexWrap: "wrap" }}>
            <a
              href="https://twitter.com/kindertogether"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "white",
                fontSize: 18,
                padding: "0% 2% 0% 0%",
                textDecoration: "none"
              }}
            >
              {" "}
              Twitter
            </a>

            <a
              href="https://www.instagram.com/kindertogether/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "white",
                fontSize: 18,
                padding: "0% 2% 0% 0%",
                textDecoration: "none"
              }}
            >
              {" "}
              Instagram
            </a>

            <a
              href="mailto:post@kindertogether.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "white",
                fontSize: 18,
                padding: "0% 2% 0% 0%",
                textDecoration: "none"
              }}
            >
              {" "}
              Jobs
            </a>
            <a
              href="mailto:post@kindertogether.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "white",
                fontSize: 18,
                padding: "0% 2% 0% 0%",
                textDecoration: "none"
              }}
            >
              {" "}
              Contact Us
            </a>

            <p style={{ color: "white", fontSize: 24, padding: "0% 2% 0% 0%" }}>
              {" "}
              © 2020 Kinder World, PBC
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default ProhibitedUse;

// <Card
// style={{
//   maxWidth: "300px",
//   maxHeight: "560px",
//   textAlign: "center",
//   alignSelf:"center",
//   justifyContent: "center",
//   color: "#5C626C",
//   padding: "8% 8% 8% 8%",
//   borderRadius: "10px"
// }}
// >
// <object
//   data={Kinder}
//   type="image/svg+xml"
//   style={{ marginLeft: "43px", width: "250px", zIndex: 100000 }}
// >
//   <img
//     src={KinderGray}
//     alt="Kinder logo"
//     style={{ width: "140px", zIndex: 100000 }}
//   />
// </object>
// <p style={{ fontSize: "20px", fontWeight: "400" }}>
//   It takes a village. <br /> Sign up to build yours.
// </p>
// {/* <div>
// <p style={{ fontSize: "18px", textAlign: "left", fontStyle: "italic" }}>
//   Get help with household tasks
//   <br />
//   Give time to help a neighbor
//   <br />

//   Get a deal from a local business.
// </p>
// </div> */}
// <div>
//   <EmailSignupConsumer />
// </div>
// <img
//   src={ComingSoon}
//   alt="Kinder will be available soon on the App Store and Google Play"
//   style={{ margin: "10%", width: "140px" }}
// />
// </Card>
